export default {
  // ── index.html / Login ──────────────────────────────
  loginPlaceholder:    "Name",
  loginBtn:            "Login mit Passkey",
  loginAuthenticating: "Authentifiziere…",
  loginEnterName:      "Bitte Namen eingeben",
  loginFailed:         "Login fehlgeschlagen",
  // ── Display Name (Profil) ───────────────────────────
  displayNameMenuLabel:    "Anzeigename",
  displayNameDialogTitle:  "Anzeigename ändern",
  displayNameDialogDesc:   "Dein Anzeigename wird anderen in Chats und Kontakten angezeigt. Dein Benutzername bleibt unverändert.",
  displayNamePlaceholder:  "z.B. Anna 🌸",
  displayNameSaveBtn:      "Speichern",
  displayNameCancelBtn:    "Abbrechen",
  displayNameResetBtn:     "Zurücksetzen",
  displayNameSaved:        "Anzeigename gespeichert",
  displayNameReset:        "Anzeigename zurückgesetzt",
  displayNameTooLong:      "Anzeigename zu lang (max. 32 Zeichen).",
  displayNameInvalid:      "Ungültiger Anzeigename.",
  displayNameSaveFailed:   "Anzeigename konnte nicht gespeichert werden.",
  displayNameRateLimit:    "Zu viele Änderungen. Bitte warte eine Stunde.",
  displayNameCharCount:    (n) => `${n}/32`,
  registerHandleTaken:     (handle) => `Der Benutzername „${handle}" ist bereits vergeben.\n\nWenn es dein Account ist: melde dich mit deinem Passkey an.\nAndernfalls: bitte wähle einen anderen Benutzernamen.`,
  registerHandleBlocked:   (handle) => `Der Benutzername „${handle}" ist aktuell nicht verfügbar.\n\nEr wurde vor Kurzem gelöscht und ist für 300 Tage gesperrt. Bitte wähle einen anderen Benutzernamen.`,
  registerHandleInvalid:   "Ungültiger Benutzername.\n\nErlaubt: 3–32 Zeichen, nur Kleinbuchstaben (a–z), Ziffern (0–9) und Unterstrich (_).",
  registerTooManyRequests: "Zu viele Registrierungsversuche. Bitte warte eine Minute und versuche es erneut.",
  registerFailed:          (err) => `Registrierung fehlgeschlagen: ${err}`,
  loginHandleTaken:        (handle) => `Der Benutzername „${handle}" ist bereits registriert.\n\nWenn es dein Account ist: stelle sicher, dass dein Passkey auf diesem Gerät verfügbar ist (z.B. über iCloud- oder Google-Sync) — oder nutze das Gerät, auf dem du den Passkey ursprünglich erstellt hast.\n\nWenn nicht: bitte wähle einen anderen Benutzernamen.`,
  loginHandleExistsConfirm:(handle) => `Der Benutzername „${handle}" ist bereits vergeben.\n\nWenn es dein Account ist: klicke OK, um dich mit deinem Passkey anzumelden.\n\nWenn nicht: klicke Abbrechen und wähle einen anderen Benutzernamen.`,
  loginGenericError:       (name, msg) => `Anmeldung fehlgeschlagen:\n\n${name}\n${msg}`,

  // ── inbox.html ──────────────────────────────────────
  inboxPageTitle:           "RENEX – Inbox",
  addContactHeading:        "Kontakt hinzufügen",
  guestInviteLabel:         "Oder: Gast einladen (ohne Account)",
  createInviteLinkBtn:      "Einladungslink erstellen",
  addContactTitle:          "Kontakt hinzufügen",
  sendRequestTitle:         "Anfrage senden",
  addContactPlaceholder:    "Username",
  addContactBtn:            "Anfrage senden",
  pendingHeading:           "Offene Anfragen",
  contactsHeading:          "Kontakte",
  deleteAccount:            "Account löschen",
  logout:                   "Logout",
  langToggleLabel:          "Sprache",
  settings:                 "Einstellungen",
  legalLabel:               "Rechtliches",

  // ── Tabs ─────────────────────────────────────────────
  tabChats:             "Kontakte & Chats",
  tabGroups:            "Gruppen",
  tabContacts:          "Kontakte",
  tabVoice:             "Anrufe",

  // ── Voice / Calls ────────────────────────────────────
  callIncoming:         "Eingehender Anruf…",
  callRinging:          "Klingelt…",
  callConnecting:       "Verbindet…",
  callEnded:            "Beendet",
  callMissed:           "Verpasst",
  voiceMitmFp:          "🚨 Sicherheitswarnung: Audio-Verschlüsselung kompromittiert (Fingerprint-Mismatch). Anruf wurde abgebrochen.",
  voiceMitmSig:         "🚨 Sicherheitswarnung: Anrufer-Signatur ungültig. Anruf wurde abgebrochen.",
  connectionDegraded:   "Verbindung schwach…",
  voiceErrorNoCmk:      "Verschlüsselungsschlüssel mit diesem Kontakt fehlt. Sende erst eine Textnachricht und versuche es danach erneut.",
  voiceErrorBusy:       "Der Empfänger ist gerade in einem anderen Anruf.",
  voiceErrorSignaling:  "Verbindung zum Server fehlgeschlagen. Bitte erneut versuchen.",
  voiceErrorIce:        "Audio-Verbindung konnte nicht aufgebaut werden (Netzwerk/Firewall).",
  voiceErrorIncompat:   "Das andere Gerät verwendet eine inkompatible App-Version.",
  voiceErrorPermission: "Mikrofon-Berechtigung fehlt. Bitte in den Browser-Einstellungen erlauben.",
  voiceErrorNoMic:      "Kein Mikrofon gefunden.",
  voiceErrorMicBusy:    "Mikrofon wird von einer anderen App benutzt.",

  // ── Gruppen ──────────────────────────────────────────
  groupNamePlaceholder: "Gruppenname",
  createGroupBtn:       "Gruppe erstellen",
  noGroups:             "Noch keine Gruppen.",
  loadingText:          "Lädt…",
  youSuffix:            " (Du)",
  loadError:            "Fehler beim Laden",
  memberLabel:          "(Mitglied)",
  inviteBtn:            "+ Einladen",
  invitePlaceholder:    "Username…",
  alreadyMember:        (handle) => `${handle} ist bereits Mitglied.`,
  userNotFound:         (handle) => `Nutzer „${handle}" existiert nicht.`,
  notInContacts:        (handle) => `„${handle}" ist nicht in deinen Kontakten. Füge ihn/sie zuerst als Kontakt hinzu.`,
  inviteFailed:         "Einladen fehlgeschlagen: ",
  groupFull:            "Die Gruppe ist voll (max. 50 Mitglieder).",
  confirmRemoveMember:  (handle) => `${handle} aus der Gruppe entfernen?`,
  removeMemberFailed:   "Entfernen fehlgeschlagen: ",
  youWereRemoved:       "Du wurdest aus der Gruppe entfernt.",
  leaveGroupBtn:        "Verlassen",
  confirmLeaveGroup:    (name) => `Gruppe "${name}" verlassen?`,
  leaveFailed:          "Verlassen fehlgeschlagen: ",
  createGroupFailed:    "Gruppe erstellen fehlgeschlagen: ",
  groupDetails:         "Gruppendetails",
  newMessage:           "Neue Nachricht",
  noMessages:           "Noch keine Nachrichten",
  yesterday:            "Gestern",
  youPrefix:            "Du: ",
  noChatYet:            "Noch kein Chat",

  // ── CMK-Rotation Toasts ────────────────────────────
  cmkSelfRotateToast:   "🔁 Sicherheits-Schlüssel rotiert ({n} Chats)",
  cmkMirrorRotateToast: "🔁 Sicherheits-Schlüssel mit {peer} rotiert",
  recoveryPromptToast:  "🔐 Chat-History wiederherstellen — Phrase eingeben",
  // ── Recovery-Login (neues Gerät) — Spec RECOVERY.md §5.3/§6.4 ──
  recoveryLoginTitle:        "Wiederherstellung über Phrase",
  recoveryLoginIntroAuth:    "Du brauchst BEIDES: einen Passkey UND deine 12-Wort-Phrase. Die Phrase allein reicht nicht — sie entschlüsselt nur dein Schlüssel-Backup. Gut zu wissen: Dein Passkey ist meist über iCloud-Schlüsselbund oder Google synchronisiert, also auf dem neuen Gerät nach dem Login wieder da — oder per QR/Bluetooth von einem anderen Gerät nutzbar.",
  recoveryLoginAuthBtn:      "🔐 Mit Passkey anmelden",
  recoveryLoginPhraseTitle:  "Phrase eingeben",
  recoveryLoginIntroPhrase:  "Authentifizierung erfolgreich. Gib jetzt deine 12-Wort-Phrase ein, um deine Schlüssel wiederherzustellen.",
  recoveryDeriving:          "Entschlüssle…",
  recoveryLoginRecoverBtn:   "Wiederherstellen",
  recoveryLoginDoneTitle:    "Wiederherstellung erfolgreich",
  recoveryLoginDoneIntro:    "Deine Schlüssel wurden entschlüsselt:",
  recoveryStatsCmks:         "DM-Konversationen",
  recoveryStatsGsks:         "Gruppen",
  recoveryLoginTodoNote:     "Deine Schlüssel sind wiederhergestellt — deine bestehenden Nachrichten sind auf diesem Gerät wieder lesbar.",
  recoveryNotRegistered:     "Account nicht gefunden. Recovery braucht einen existierenden Account.",
  recoveryInvalidPhrase:     "Phrase ist nicht gültig (BIP39-Fehler).",
  recoveryNoBundle:          "Kein Recovery-Bundle gefunden.",
  recoveryWrongPhrase:       "Falsch.",
  attemptsLeft:              "Versuche übrig",
  recoveryCooldown:          "Zu viele falsche Versuche. Versuche es in 1 Stunde erneut.",
  recoveryVerifyFailed:      "Recovery fehlgeschlagen",
  updateAvailableToast: "🔄 Neue Version verfügbar — Reload",

  // ── Mute / Notification-Settings ───────────────────
  mute:                 "Stummschalten",
  muted:                "Stummgeschaltet",
  unmute:               "Wieder einschalten",
  muteFor:              "Stumm für",
  muteUntil:            "Stumm bis",
  muteIndefinite:       "Stummgeschaltet (manuell aufheben)",
  mute1h:               "1 Stunde",
  mute8h:               "8 Stunden",
  mute24h:              "24 Stunden",
  muteForever:          "Bis ich es wieder einschalte",
  muteMentionsOnly:     "Nur @-Erwähnungen",
  muteMentionsAndEveryone: "@-Erwähnungen + @alle",

  // ── Chat-Header-Menu (3-Punkte) ────────────────────
  moreActions:           "Mehr",
  removeContact:         "Kontakt entfernen",
  removeContactConfirm:  "Kontakt {peer} entfernen? Der Chat-Verlauf bleibt lokal erhalten.",
  removeContactSuccess:  "{peer} entfernt",
  contactRemovedByPeer:  "{peer} hat dich aus den Kontakten entfernt",
  contactRequestToast:   "📩 Neue Kontaktanfrage von {peer}",
  reactionToastDm:       "{emoji} {peer} hat reagiert",
  reactionToastGroup:    "{emoji} {peer} hat in {group} reagiert",
  captchaRequired:       "Bitte Captcha lösen",

  // ── Invite-Link (Gast-Einladung) ───────────────────
  inviteByLinkTitle:     "Per Link einladen (kein Account nötig)",
  invite1to1Title:       "Person einladen (1:1)",
  invite1to1Hint:        "Sende diesen Link an die Person mit der du chatten willst — sie chattet als Gast (kein Account nötig).",
  inviteToGroupTitle:    "In Gruppe einladen: {name}",
  inviteGroupHint:       "Sende diesen Link an Personen die deiner Gruppe beitreten sollen — sie chatten als Gast (kein Account nötig).",
  creatingInvite:        "Einladungslink wird erstellt…",
  inviteCreateFailed:    "Einladungslink konnte nicht erstellt werden",
  inviteCreateBtn:       "Invite-Link erstellen",
  serverInviteTitle:     "Server-Invite-Link",
  serverInviteHint:      "Sende diesen Link an Personen mit RENEX-Account — sie treten damit dem Server bei. 7 Tage gültig.",
  inviteInvalid:         "Invite-Link ungültig oder abgelaufen",
  inviteAlreadyMember:   "Du bist bereits Mitglied dieses Servers",
  inviteJoinConfirm:     "Server \"{name}\" beitreten? ({count} Mitglieder)",
  inviteJoinSuccess:     "✅ Server beigetreten",
  inviteJoinFailed:      "Beitritt fehlgeschlagen",
  inviteRateLimit:       "Zu viele Einladungen — bitte später erneut versuchen.",
  inviteShareText:       "Hi! Schreib mir auf RENEX — ohne Account.",
  copy:                  "Kopieren",
  copied:                "Kopiert",
  copyFailed:            "Kopieren nicht möglich — Link manuell auswählen",
  shareBtn:              "Teilen",
  expiresAt:             "Gültig bis",
  guestMsgLimit:         "Gast-Nachrichten",
  convertingGuest:       "Konvertiere Gast-Konto…",
  convertSuccess:        "Gast-Konto übernommen ✓",
  guestConvertedToast:   "👤 {old} ist jetzt {new}",
  sysGuestConvertNotice: "Ein Gast hat sich registriert. Frühere verschlüsselte Nachrichten bleiben für die anderen Teilnehmer unlesbar.",
  sysGuestExpiryWarn: "Dieser Gast-Zugang läuft in {n} Tagen ab. Mit einem Konto bleiben Chat und Schlüssel erhalten.",
  sysGuestNowReal:       "👤 {old} ist jetzt @{new}",
  sysNowAdmin:           "👑 {user} ist jetzt Admin",
  guestJoinedToast:      "👤 {handle} ist beigetreten",
  inviteAcceptedToast:   "🤝 {handle} hat die Einladung angenommen",
  inviteAcceptFailed:    "Einladung konnte nicht angenommen werden",
  inviteRevokeBtn:       "Widerrufen",
  inviteRevokeConfirm:   "Diesen Einladungslink widerrufen? Er wird sofort ungültig.",
  inviteRevokeSuccess:   "Einladungslink widerrufen",
  inviteRevokeFailed:    "Widerruf fehlgeschlagen",
  tabInvites:            "Invites",
  invitesEmpty:          "Noch keine aktiven Invite-Links. Erstelle einen oben.",
  inviteUses:            "Nutzungen",
  inviteNeverExpires:    "unbegrenzt",
  inviteExpired:         "abgelaufen",
  inviteInviterLeft:     "Der Einlader ist nicht mehr Mitglied dieser Konversation.",
  inviteByLinkLabel:     "🔗 Per Link einladen",

  // ── Attachments (Photo/File) ───────────────────────
  attachPhoto:             "Foto anhängen",
  attachFile:              "Datei anhängen",
  attachMenuTitle:         "Anhang hinzufügen",
  attachPhotoVideo:        "Foto",
  attachPhotoLibrary:      "Mediathek",
  attachTakePhoto:         "Aufnehmen",
  attachDocument:          "Dokument",
  attachGif:               "GIF",
  dropToAttach:            "Datei hier ablegen",
  gifNoResults:            "Keine Ergebnisse.",
  gifRateLimit:            "Zu viele Suchen — bitte warten.",
  gifNotConfigured:        "GIF-Suche nicht verfügbar.",
  gifSearchFailed:         "GIF-Suche fehlgeschlagen.",
  pickGif:                 "GIF auswählen",
  poweredByGiphy:          "Powered by GIPHY",

  // ── PWA Install ────────────────────────────────────
  pwaInstallTitle:         "Als App installieren",
  pwaInstallSub:           "Schneller, eigenes Fenster, Always-on.",
  pwaInstallBtn:           "Installieren",
  pwaInstallMenuItem:      "Als App installieren",
  dismiss:                 "Schließen",
  pwaIosStep1:             "Tippe auf das Teilen-Symbol unten in Safari",
  pwaIosStep2:             'Wähle „Zum Home-Bildschirm" aus dem Menü.',
  pwaIosStep3:             'Bestätige mit „Hinzufügen" oben rechts.',
  pwaIosVideoAlt:          'Video: RENEX in Safari über Teilen → „Zum Home-Bildschirm" installieren',
  pwaMacStep1:             'Öffne in Safari das Menü „Ablage".',
  pwaMacStep2:             'Wähle „Zum Dock hinzufügen…"',
  pwaMacStep3:             "Bestätige im Dialog.",
  pwaMacRequirementHint:   "Erfordert Safari 17 oder neuer (macOS Sonoma+).",
  pwaUnsupportedHint:      "Dein Browser unterstützt keine direkte Installation. Versuche es in Chrome, Edge oder Safari.",

  // ── Landing Hero (Statement-first) ─────────────────
  heroPrefix:             "Du hast einen",
  heroAccent:             "Puls",
  heroLine2:              "Bots nicht.",
  heroSub:                "RENEX ist der Messenger für Menschen — Passkey-only, Ende-zu-Ende-verschlüsselt, ohne Tracking. Beweg dich: das ist dein Puls.",
  heroCta:                "Loslegen →",
  heroBack:               "← Zurück",
  heroKicker:             "Menschliche Kommunikation",
  heroOpenSource:         "Open Source · Code auf GitHub",
  showcaseTitle:          "So sieht RENEX aus",
  showcaseSub:            "Ein echter Chat — mit Pulse. Du siehst nicht nur Worte, sondern dass auf der anderen Seite ein Mensch ist.",
  showcaseAlt:            "RENEX App — 1:1-Chat mit aktivem Pulse",

  // ── Landing Marketing ──────────────────────────────
  landingSectionTitle:    "Gebaut für Menschen, nicht für Bots.",
  landingSectionSub:      "Wir beweisen Menschlichkeit nicht — wir machen Automatisierung unwirtschaftlich.",
  featurePasskeyTitle:    "🔑 Passkey-Native Login",
  featurePasskeyDesc:     "Login via Passkey — Face ID, Touch ID, PIN oder Hardware-Key (YubiKey). Keine E-Mail, keine Telefonnummer, kein Passwort. Nichts was geleakt werden kann.",
  featureE2eTitle:        "🔒 Ende-zu-Ende-Verschlüsselung",
  featureE2eDesc:         "Nachrichten werden auf deinem Gerät verschlüsselt. Selbst wir können sie nicht lesen — der Server sieht nur Ciphertext, nie Klartext.",
  featureBotResistantTitle: "🤖 Bot-resistent",
  featureBotResistantDesc:  "Wir prüfen nicht deine Menschlichkeit — wir machen Spam einfach zu teuer. Wer tausende Bots betreiben will, braucht tausende echte Geräte, echte Biometrie, echte Beziehungen. Menschen bleiben erreichbar, Bots geben auf.",
  featureGuestTitle:      "🔗 Guest-Access",
  featureGuestDesc:       "Teile einen Link für den Erstkontakt — dein Gegenüber chattet sofort, ohne Anmeldung. Für dauerhafte Gespräche wird später ein eigener Passkey angelegt.",
  featureCallsTitle:      "🎙️ Anrufe ohne US-Cloud",
  featureCallsDesc:       "Deine Anrufe laufen direkt zwischen den Geräten. Geht das nicht, nutzen wir unseren eigenen Relay-Server in Deutschland — kein US-Cloud-Dienst, kein Tracker dazwischen.",
  featureZeroTrackTitle:  "🛡️ Zero-Tracking",
  featureZeroTrackDesc:   "Keine Werbung. Keine Tracking-Pixel. Keine Marketing-Profile. Nur technische Diagnosedaten helfen uns, Fehler zu beheben — Nachrichten-Inhalte können wir nie lesen.",
  landingFooterCopy:      "© 2026 RENEX",

  // ── Manifesto ──────────────────────────────────────
  manifestoLabel:          "Manifest",
  landingManifestoTitle:   "Warum es RENEX gibt",
  landingManifestoBody:    "Das Internet wird von Bots geflutet, Plattformen verkaufen deine Aufmerksamkeit, KI imitiert Menschen. RENEX ist die Gegenbewegung: ein Ort von Menschen, für Menschen. Lies, wofür wir stehen.",
  landingManifestoCta:     "Manifest lesen →",

  // ── Pulse (Phase 6.5) ──────────────────────────────
  pulseOn:                 "Pulse an",
  pulseOff:                "Pulse aus",
  pulseHintText:           "Pulse — sieh, wann jemand wirklich da ist. Tippen zum Aktivieren.",
  pulsePermTitle:          "Pulse aktivieren",
  pulsePermBody:           "RENEX nutzt subtile Bewegung deines Geräts, um deine Anwesenheit für dein Gegenüber sichtbar zu machen.",
  pulsePermPoint1:         "Vollständig auf deinem Gerät",
  pulsePermPoint2:         "Nichts wird gespeichert",
  pulsePermPoint3:         "Nur dein Gegenüber sieht es",
  pulsePermHint:           "iOS fragt im nächsten Schritt nach der Bewegungs-Berechtigung.",
  pulsePermAllow:          "Erlauben →",
  pulsePresentNow:         "gerade da",
  nodTooltip:              "Antippen = Nicken 👋",
  attachmentTooLarge:      "Datei zu groß (max. 10 MB).",
  attachmentMimeBlocked:   "Dateityp nicht erlaubt.",
  attachmentExtBlocked:    "Dateiendung nicht erlaubt.",
  attachmentRateLimit:     "Zu viele Uploads — bitte warten.",
  attachmentUploadFailed:  "Upload fehlgeschlagen.",
  attachmentGone:          "Datei nicht mehr verfügbar.",
  attachmentForbidden:     "Kein Zugriff auf diese Datei.",
  attachmentLoadFailed:    "Datei konnte nicht geladen werden.",
  attachmentLocked:        "wartet auf Schlüssel",
  loadingPhoto:            "Lade Foto…",
  openPhoto:               "Foto öffnen",
  downloadBtn:             "Herunterladen",
  downloadFailed:          "Download fehlgeschlagen.",

  // ── Device-Limit-Modal ─────────────────────────────
  deviceLimitTitle:        "Geräte-Limit erreicht",
  deviceLimitMessage:      "Du verwendest aktuell {current}/{max} Geräte. Verwalte deine Geräte unter Profil → Geräte und entferne ein altes, um dieses hinzuzufügen.",
  deviceLimitOkBtn:        "Verstanden",

  // ── Device-Toasts (VISION §6 Multi-Device-Sichtbarkeit) ───
  deviceAddedSelfToast:    "📱 Neues Gerät hinzugefügt. Wenn das nicht du warst — sofort entfernen unter Profil → Geräte.",
  deviceAddedPeerToast:    "📱 Ein Kontakt hat ein neues Gerät hinzugefügt.",
  deviceRevokedSelfToast:  "🔒 Gerät entfernt — Schlüssel werden rotiert.",
  deviceRevokedPeerToast:  "🔒 Ein Kontakt hat ein Gerät entfernt — Schlüssel rotiert.",
  deviceAutoRevokedSelfToast: "🧹 Inaktives Gerät automatisch entfernt (30 Tage offline).",
  deviceAutoRevokedPeerToast: "🧹 Inaktives Gerät eines Kontakts wurde automatisch entfernt.",

  // ── Gruppen-Inbox + Create-Modal (Phase 1C i18n) ────
  noGroupsYet:          "Noch keine Gruppen",
  members:              "Mitglieder",
  createGroupTitle:     "Gruppe erstellen",
  groupNameHint:        "Gib einen Namen für die Gruppe ein (2–50 Zeichen).",
  selectMembersTitle:   "Mitglieder auswählen",
  selectMembersHint:    "Wähle aus deinen Kontakten.",
  selectMembersHintOptional: "Wähle aus deinen Kontakten — optional. Du kannst die Gruppe auch leer starten und später einladen.",
  noContactsCreateEmpty: "Kein Problem — erstelle die Gruppe leer und lade später per Invite-Link oder über „Mitglieder hinzufügen“ ein.",
  createEmptyGroupBtn:  "Leere Gruppe erstellen",
  selected:             "ausgewählt",
  noContactsToAdd:      "Keine Kontakte vorhanden.",
  addContactsFirst:     "Füge zuerst Kontakte hinzu.",
  searchContactsPlaceholder: "Kontakte suchen…",
  noContactsMatch:      "Keine Kontakte gefunden.",
  groupCreateFailed:    "Gruppen-Erstellung fehlgeschlagen",
  backBtn:              "Zurück",
  // ── Add-Members-Modal (Kontakt-Picker für bestehende Gruppe) ──
  addBtn:               "Hinzufügen",
  noContactsYet:        "Du hast noch keine Kontakte.",
  alreadyMemberLabel:   "Bereits dabei",
  notInContactsHint:    "Nicht in deinen Kontakten?",
  inviteByLinkBtn:      "Per Link einladen",
  addMembersPartial:    "{ok} hinzugefügt, {fail} fehlgeschlagen",
  addMembersAllFailed:  "Hinzufügen fehlgeschlagen",

  // ── Chat-Menü (3-Punkte Slide-Submenüs) ───────────────
  notifications:           "Benachrichtigungen",
  notificationsOn:         "An",
  muteIndefiniteShort:     "∞",
  autoDeleteLabel:         "Auto-Delete",
  autoDeleteOff:           "Aus",
  autoDeleteActive:        (label) => `✅ Auto-Delete aktiv: ${label}`,
  autoDeleteDisabled:      "✅ Auto-Delete deaktiviert",
  autoDeleteSet:           (label) => `✅ Auto-Delete: ${label}`,
  autoDeleteProposal:      (label) => `📤 Vorschlag gesendet: ${label}`,
  autoDeleteProposalIncoming: "schlägt Auto-Delete vor:",
  autoDeleteWaitingForPeer: "Wartet auf Bestätigung:",
  cmkPendingBanner:        "Einige Nachrichten sind noch verschlüsselt. ",
  cmkPendingBannerSuffix:  "muss kurz online kommen — der fehlende Schlüssel lädt dann automatisch nach.",
  cmkPendingBannerGroup:   "Einige Nachrichten sind noch verschlüsselt. Sobald die Absender kurz online kommen, lädt der fehlende Schlüssel automatisch nach.",
  autoDeleteSetByPeer:     "hat Auto-Delete gesetzt:",
  autoDeleteDisabledByPeer: "hat Auto-Delete deaktiviert.",
  autoDeletePending:       "Anstehend",
  autoDeleteDmHint:        "Beide Seiten müssen zustimmen. Vorschlag wird an Peer gesendet.",
  autoDeleteGroupHint:     "Jedes Mitglied darf ändern. Alle bekommen eine System-Nachricht.",
  autoDeleteOneDay:        "24 Stunden",
  autoDeleteOneWeek:       "7 Tage",
  autoDeleteThirtyDays:    "30 Tage",
  accept:                  "Akzeptieren",
  decline:                 "Ablehnen",
  // Group-Items
  addMembers:              "Mitglieder hinzufügen",
  addMembersPrompt:        "Handle eingeben (z.B. anna4):",
  memberAdded:             "Mitglied hinzugefügt",
  memberAddFailed:         "Hinzufügen fehlgeschlagen",
  renameGroup:             "Gruppenname ändern",
  renameGroupPrompt:       "Neuer Gruppenname:",
  groupRenamed:            "Gruppe umbenannt",
  groupRenameFailed:       "Umbenennen fehlgeschlagen",
  removeMemberLabel:       "Teilnehmer entfernen",
  removeMemberConfirm:     "Mitglied @{h} aus der Gruppe entfernen?",
  memberRemoved:           "Mitglied entfernt",
  noOtherMembers:          "Keine weiteren Mitglieder",
  leaveGroup:              "Gruppe verlassen",
  leaveGroupConfirm:       "Gruppe wirklich verlassen?",
  groupLeft:               "Gruppe verlassen",
  membersHeading:          "Mitglieder",
  groupMembersTitle:       "Mitglieder",
  groupMembersShow:        "Mitglieder anzeigen",
  roleAdmin:               "Admin",
  youSuffix:               "Du",
  loadingMembers:          "Lade Mitglieder…",
  loadMembersFailed:       "Mitglieder konnten nicht geladen werden",

  // ── Chat-Nachrichten ──────────────────────────────────
  decryptPending:         "🔒 Nachricht wird entschlüsselt…",
  decryptFailed:          "🔒 Nachricht konnte nicht entschlüsselt werden",
  decryptFailedHint:      "Schlüssel nicht verfügbar — wahrscheinlich hat sich eine Seite neu registriert.",
  decryptFailedOwn:       "🔒 Diese Nachricht kannst du nicht mehr entschlüsseln",
  decryptFailedOwnHint:   "Der Schlüssel ging verloren. Fordere auf einer Nachricht von {peer} einen neuen Schlüssel an.",
  decryptFailedOwnGroupHint:"Dein Gruppen-Schlüssel ging verloren. Alte Nachrichten bleiben unlesbar — neue funktionieren wieder.",
  decryptFailedGroupHint: "Schlüssel von {peer} fehlt. Tippe auf 'Schlüssel anfordern' um ihn zu holen.",
  decryptRetryBtn:        "🔄 Neuen Schlüssel anfordern",
  decryptRetryAgain:      "🔄 Erneut anfordern",
  decryptRetrySent:       "🔁 Neuer Schlüssel angefordert — Nachricht wird evtl. gleich lesbar",
  decryptRetryFailed:     "⚠️ Schlüssel konnte nicht angefordert werden — bitte später erneut versuchen",
  decryptRetryPending:    "⏳ Wird angefordert…",
  decryptRetrySuccess:    "✅ Schlüssel angefordert",
  decryptRetrySuccessHint:"Neue Nachrichten werden wieder lesbar. Ältere, die mit verlorenen Schlüsseln verschlüsselt wurden, können nicht wiederhergestellt werden.",
  decryptRetryErrorBtn:   "↻ Erneut versuchen",
  decryptRetryErrorHint:  "Schlüssel-Anfrage fehlgeschlagen. Verbindung prüfen und erneut versuchen.",
  decryptRetryPeerOfflineHint:"{peer} ist gerade nicht erreichbar. Bitte {peer}, die App zu öffnen, dann erneut versuchen.",
  decryptRetryPeerOfflineToast:"⚠️ {peer} nicht erreichbar",
  authorityOfflineHint:   "⚠️ {peer} ist gerade nicht erreichbar. Deine Nachrichten werden zugestellt, sobald {peer} wieder online ist.",
  groupMembersOfflineHint:"ℹ️ {count} Mitglied(er) gerade nicht erreichbar. Deine Nachrichten werden zugestellt, sobald sie wieder online sind.",
  resetKeysLabel:         "🔑 Verschlüsselung zurücksetzen",
  resetKeysConfirm:       "Verschlüsselungsschlüssel für diesen Chat zurücksetzen?\n\nBehebt Probleme, bei denen Nachrichten nicht entschlüsselt werden können. Alte Nachrichten bleiben unlesbar.",
  resetKeysDone:          "🔁 Schlüssel zurückgesetzt — neue Nachrichten werden mit frischem Schlüssel verschlüsselt",
  resetKeysFailed:        "⚠️ Schlüssel-Reset fehlgeschlagen — bitte erneut versuchen",
  resetKeysRemote:        "🔁 Die andere Seite hat die Schlüssel zurückgesetzt — stelle sichere Verbindung neu her…",
  guestConvertNotice:     "🔒 Nachrichten aus deiner Gast-Session können nach der Registrierung nicht mehr angezeigt werden",
  messageExpired:         "⏱ Nachricht automatisch gelöscht",
  deleteMessageTitle:     "Nachricht löschen",
  confirmDeleteMessage:   "Nachricht löschen?",
  statusDelivered:        "Zugestellt",
  statusSent:             "Gesendet",
  statusSending:          "Sende…",
  statusEdited:           "(bearbeitet)",
  messageDeleted:         "🗑️ Nachricht gelöscht",
  noPeerKey:              "🔐 Peer hat noch keinen Public Key",

  // ── Delete-Account-Dialog ───────────────────────────
  deleteAccountDialogTitle:   "Account löschen",
  deleteAccountDialogBody:    "Diese Aktion ist unwiderruflich. Alle Nachrichten und Kontakte werden gelöscht.<br><br>Gib deinen Username zur Bestätigung ein:",
  deleteAccountPlaceholder:   "Dein Username",
  cancelBtn:                  "Abbrechen",
  deleteAccountConfirmBtn:    "Account löschen",
  deleteAccountFailed:        "Löschung fehlgeschlagen",
  daWipeMessages:             "Alle Nachrichten + Anhänge",
  daWipeContacts:             'Alle Kontakte (Gegenseite sieht „Account gelöscht")',
  daWipeGroups:                "Du wirst aus allen Gruppen entfernt",
  daWipeDevices:              "Alle Geräte sofort ausgeloggt",
  daWipePasskeys:             "Alle Passkeys",
  daWipeBackup:               "Recovery-Backup auf dem Server",
  daHandleLocked:             "Username wird 300 Tage gesperrt",

  // ── Footer ───────────────────────────────────────────
  footerImprint:              "Impressum",
  footerPrivacy:              "Datenschutz",
  footerTerms:                "AGB",
  footerFeedback:             "Feedback",
  footerPress:                "Presse",

  // ── Terms Consent ─────────────────────────────────────
  consentPrefix:              "Ich akzeptiere die",
  consentAnd:                 "und",
  consentTerms:               "AGB",
  consentPrivacy:             "Datenschutzerklärung",
  consentSuffix:              ".",
  consentRequired:            "Bitte akzeptiere AGB und Datenschutzerklärung",

  // ── inbox.js (dynamic strings) ───────────────────────
  cryptoInitFailed:       "Kryptografie konnte nicht initialisiert werden",
  noContacts:             "Noch keine Kontakte",
  noPendingRequests:      "Keine offenen Anfragen",
  // ── Member-Actions-Modal (Klick auf Group-Sender / Group-Member) ──
  openDm:                 "Direkt-Nachricht",
  notInContactsYet:       "Noch nicht in deinen Kontakten.",
  requestContactBtn:      "Als Kontakt anfragen",
  hasPendingRequestIn:    "möchte dich als Kontakt hinzufügen.",
  requestPendingHint:     "⏳ Anfrage gesendet — wartet auf Bestätigung.",
  cancelRequestBtn:       "Anfrage zurückziehen",
  guestNoActions:         "Gäste können nicht als Kontakt hinzugefügt werden.",
  openMemberActions:      "Aktionen anzeigen",
  maContactAccepted:      "Kontakt akzeptiert",
  maAlreadyContact:       "Bereits in Kontaktliste",
  maAlreadyPending:       "Anfrage bereits offen",
  maRequestSent:          "Anfrage gesendet ✓",
  maRequestRejected:      "Anfrage abgelehnt",
  maRequestCancelled:     "Anfrage zurückgezogen",
  maRequestFailed:        "Anfrage fehlgeschlagen",
  maUserNotFound:         "User nicht gefunden",
  maAccountDeleted:       "Account gelöscht",
  maRejectConfirm:        "Diese Anfrage ablehnen?",
  maCancelConfirm:        "Anfrage zurückziehen?",
  loadContactsFailed:     "Fehler beim Laden der Kontakte",
  requestSent:            " (Anfrage gesendet)",
  requestWantsToConnect:  "möchte sich verbinden",
  requestWithdraw:        "Zurückziehen",
  acceptBtn:              "Annehmen",
  rejectBtn:              "Ablehnen",
  accountDeleted:         " (Konto gelöscht)",
  removeFromList:         "Aus Liste entfernen",
  handleMismatch:         "Username stimmt nicht überein",
  contactRequestFailed:   "Kontaktanfrage fehlgeschlagen",
  contactRequestAccountDeleted: "Dieser Account existiert nicht mehr",
  removeContactFailed:    "Kontakt konnte nicht entfernt werden",
  confirmRemoveContact:   (handle) => `Kontakt ${handle} wirklich entfernen?`,
  closeBtn:               "Schliessen",
  linkCopied:             "Link kopiert!",
  dmInviteSubLabel:       "DM-Einladung (einmalig)",
  linkCopiedInfo:         "Link kopiert — gültig 48h, max. 20 Nachrichten pro Gast",
  linkCopiedClipboard:    (url) => `Chatte mit mir auf Renex (48h gültig):\n${url}`,
  linkCopiedClipboardDm:  (url) => `Schreib mir auf Renex (48h gültig, einmalig):\n${url}`,
  linkCreateFailed:       "Link konnte nicht erstellt werden",
  inviteLinkCreate:       "Einladungslink erstellen",
  doneBtn:                "Fertig",
  someInvitesFailed:      "Einige Einladungen fehlgeschlagen:",

  // ── chat/index.html ──────────────────────────────────
  chatPageTitle:        "Chat",
  chatStartupError:    "Chat konnte nicht geladen werden. Bitte lade die Seite neu.",
  reloadBtn:           "Neu laden",
  messagePlaceholder:   "Nachricht…",
  sendBtn:              "Senden",
  newMessagesSuffix:    " neue Nachrichten ↓",
  replyingTo:           "Antwort an",
  cancel:               "Abbrechen",
  editingMessage:       "Nachricht bearbeiten",
  confirmDelete:        "Diese Nachricht wirklich löschen?",
  deleteFailed:         "Löschen fehlgeschlagen",
  editFailed:           "Bearbeiten fehlgeschlagen",
  pttToggle:            "Push-to-Talk Modus",
  pttHold:              "Halten zum Sprechen (Leertaste)",
  pttSpeaking:          "Aufnahme läuft…",
  reconnecting:         "Verbindung wird wiederhergestellt…",

  // ── chat.js (dynamic strings) ────────────────────────
  noChatPartner:      "Kein Chat-Partner gewählt",
  chatWith:           (user) => `Chat mit ${user}`,
  sendFailed:         "Nachricht konnte nicht gesendet werden",
  sendFailedError:    (err) => `⚠️ Senden fehlgeschlagen: ${err}`,
  unknownError:       "Unbekannter Fehler",
  renameFailed:       "Umbenennen fehlgeschlagen: ",
  editFailed:         "Bearbeiten fehlgeschlagen: ",
  deleteFailed:       "Löschen fehlgeschlagen: ",
  fileLabel:          "Datei",
  photoLabel:         "📷 Foto",
  maxLengthReached:   (max) => `Maximal ${max} Zeichen erreicht`,
  charCounter:        (len, max) => `${len} / ${max} Zeichen`,
  pleaseWait:         "Bitte kurz warten…",

  // ── Gruppe erstellen Popup ───────────────────────────
  createGroupLabel:    "Gruppe erstellen",
  nextBtn:             "Weiter →",
  invitePeopleLabel:   "Personen einladen",
  onlyContactsWarning: "Nur eigene Kontakte können eingeladen werden",
  orSeparator:         "oder",
  guestInviteLinkBtn:  "🔗 Gast-Einladungslink erstellen",
  createGroupFinish:   "Gruppe erstellen",
  filterPlaceholder:   "Filtern…",
  noContactsFound:     "Keine Treffer",
  noContactsYet:       "Noch keine Kontakte",

  // ── Mitglieder ────────────────────────────────────────
  membersLabel:        (n) => `${n} Mitglieder`,
  newGroup:            "neue Gruppe",
  groupInviteToast:    (name) => `Du wurdest zur Gruppe „${name}" eingeladen`,
  invitedByPrefix:     (by) => `Von: ${by}`,

  // ── Chat-Dropdown ─────────────────────────────────────
  notificationsLabel:    "Benachrichtigungen",
  notificationsOn:       "An",
  notificationsOff:      "Aus",
  notifAll:              "🔔 Alle Benachrichtigungen",
  notifMentionsEveryone: "@Mentions + @everyone",
  notifMentionsOnly:     "@Mentions",
  notifMuted:            "🔕 Stumm",
  notifMuteFor1h:        "⏱ Stumm für 1h",
  notifMuteFor8h:        "⏱ Stumm für 8h",
  notifMuteFor24h:       "⏱ Stumm für 24h",
  notifLevelMentions:    "@Mentions",
  notifLevelMentionsAll: "@Mentions + @all",
  notifTimedSuffix:      (time) => `Stumm (${time})`,
  renameGroupLabel:      "✏️ Gruppe umbenennen",
  createInviteLinkLabel: "🔗 Einladungslink erstellen",

  // ── Gast-Banner ───────────────────────────────────────
  guestLabel:              "Gastzugang",
  registerToAddContacts:   "Registriere dich um Kontakte hinzuzufügen",
  guestMsgLimit:           "⚠️ Nachrichtenlimit erreicht — registriere dich um weiterzuschreiben!",
  // GuestBanner (Session-Info im Chat-Header)
  guestSessionExpiresIn:   "Session läuft ab in",
  guestSessionExpired:     "Gast-Session abgelaufen",
  guestDaysLeft:           "{n} Tage",
  orgInviteTitle:          "Bürger-Einladungen (Organisation)",
  orgInviteHint:           "Langlebige Einladungen für Bürger — per QR-Karte übergeben oder als Brief verschicken. Eine Einladung = eine Person.",
  orgDaysLabel:            "Gültigkeit (Tage)",
  orgCountLabel:           "Anzahl",
  orgLabelsLabel:          "Empfänger-Referenzen (optional, eine pro Zeile — bestimmt die Anzahl)",
  orgLabelsPlaceholder:    "Mitglied Müller\nPatientin 0042\n…",
  orgCreateBtn:            "{n} Einladung(en) erstellen",
  orgCodeToggle:           "Aktivierungscode verlangen (Empfänger-Auth)",
  orgCodeHint:             "Der Code wird nur EINMAL hier angezeigt — übergeben Sie ihn separat (zweiter Brief, Telefon, persönlich). RENEX speichert ihn nie im Klartext.",
  orgCsvBtn:               "CSV",
  orgResultsTitle:         "Neu erstellt",
  orgExistingTitle:        "Bestehende Einladungen",
  orgNoInvites:            "Noch keine Einladungen.",
  orgStatusOpen:           "offen",
  orgStatusConsumed:       "eingelöst",
  orgStatusActive:         "aktiv",
  orgStatusExpired:        "abgelaufen",
  orgStatusConverted:      "Konto erstellt",
  inviteCitizenTitle:      "Bürger einladen",
  orgBridgeHint:           "Bürger:innen haben kein RENEX-Konto — sie brauchen keinen Handle.",
  orgBridgeBtn:            "Einladung erstellen",
  guestMessagesLeft:       "Verbleibende Nachrichten",
  guestMsgLimitReached:    "Nachrichten-Limit erreicht",
  guestCreateAccount:      "Account erstellen",
  guestJoined:         (name) => `👤 Du bist beigetreten als <strong>${name}</strong>`,
  expired:             "Abgelaufen",
  guestLimitReached:   "Du hast alle Gast-Nachrichten aufgebraucht. Erstelle ein kostenloses Konto mit Passkey, um weiterzulesen und zu schreiben — in Sekunden, kein Passwort nötig.",
  guestExpired:        "Dein Gastzugang ist abgelaufen. Erstelle ein kostenloses Konto mit Passkey, um weiterzulesen und zu schreiben — in Sekunden, kein Passwort nötig.",
  guestLimitTitle:     "Nachrichtenlimit erreicht",
  guestExpiredTitle:   "Gastzugang abgelaufen",
  dropToSend:          "Datei zum Senden ablegen",
  dropUnsupported:     "Dateityp nicht unterstützt",
  sendCooldown:        "Zu schnell gesendet — bitte erneut versuchen",
  timeRemaining:       "verbleibend",
  msgsRemaining:       "Nachrichten übrig",
  convertToPasskey:    "Mit Passkey anmelden",

  // ── Mitglieder-Liste (Chat) ───────────────────────────
  contactAdded:        "✓ Kontakt",
  requestContact:      "+ Anfragen",
  requestPending:      "✓ Ausstehend",
  requestSentConfirm:  "✓ Gesendet",
  errorLabel:          "✗ Fehler",

  // ── Diverse ───────────────────────────────────────────
  cancelTitle:         "Abbrechen",
  networkError:        "⚠️ Netzwerkfehler",
  groupNameLabel:      "Gruppenname",

  // ── GIF-Modal ─────────────────────────────────────────
  gifSearchPlaceholder: "GIF suchen…",
  gifTitle:             "GIF suchen",
  gifSearching:         "Suche…",
  photoTitle:           "Foto senden",
  fileTitle:            "Datei senden",

  // ── Join/Invite Page ──────────────────────────────────
  invitePageTitle:         "RENEX – Einladung",
  checkingInvite:          "Einladung wird geprüft…",
  invitedByText:           (by) => `Du wurdest von <strong>${by}</strong> eingeladen`,
  accessFor24h:            "Zugang für <strong>24 Stunden</strong> — dann mit Passkey speichern",
  maxMessages:             "Maximal <strong>20 Nachrichten</strong> als Gast",
  e2eEncrypted:            "Ende-zu-Ende verschlüsselt",
  joinAsGuestBtn:          "Als Gast beitreten",
  loginAndJoinBtn:         "Anmelden & beitreten",
  invalidInviteTitle:      "Einladung ungültig",
  inviteExpiredDefaultMsg: "Dieser Einladungslink ist abgelaufen oder wurde bereits verwendet.",
  goHomeBtn:               "Zur Startseite",
  noTokenMsg:              "Dieser Link ist ungültig.",
  inviteExpiredReason:     "Dieser Einladungslink ist abgelaufen.",
  inviteAlreadyUsed:       "Dieser Link wurde bereits verwendet.",
  inviteAlreadyUsedDm:     "Dieser Einladungslink wurde bereits verwendet. Jeder DM-Link kann nur einmal genutzt werden.",
  inviteNotFound:          "Dieser Link existiert nicht.",
  joiningText:             "Beitreten…",
  captchaRequired:         "Bitte zuerst die Sicherheitsprüfung abschliessen.",
  captchaFailed:           "Sicherheitsprüfung fehlgeschlagen. Bitte erneut versuchen.",
  joinErrorDefault:        "Fehler beim Beitreten.",
  successRedirecting:      "Erfolgreich! Leite weiter…",
  connectionError:         "Verbindungsfehler",
  checkConnection:         "Bitte überprüfe deine Internetverbindung.",
  joinErrorTitle:          "Fehler beim Beitreten",
  joinErrorRetry:          "Bitte erneut versuchen.",
  networkErrorRetry:       "Netzwerkfehler. Bitte erneut versuchen.",

  // ── Geräte-Verwaltung (Multi-Device) ──────────────────
  devicesLabel:            "Geräte",
  devicesTitle:            "Geräte verwalten",
  devicesActive:           "Geräte aktiv",
  devicesEmpty:            "Keine aktiven Geräte.",
  devicesLoadFailed:       "Geräte konnten nicht geladen werden",
  deviceCurrent:           "AKTUELL",
  deviceUnnamed:           "Unbenanntes Gerät",
  deviceLastSeen:          "zuletzt",
  deviceSyncing:           "synchronisiert…",
  deviceLogoutBtn:         "Sitzung beenden",
  deviceRevokeBtn:         "Entfernen",
  deviceLogoutConfirm:     "Diese Sitzung wirklich beenden?",
  deviceRevokeConfirm:     "Gerät entfernen? Diese Aktion ist endgültig. Alle Konversationen werden mit neuen Schlüsseln re-verschlüsselt.",
  deviceRevokeFailed:      "Entfernen fehlgeschlagen",
  deviceAutoRevokeHint:    "Geräte werden nach 30 Tagen Inaktivität automatisch entfernt.",
  addDeviceBtn:            "+ Neues Gerät hinzufügen",
  addDeviceLimitTooltip:   "Limit erreicht. Entferne ein Gerät oder upgrade auf Pro.",
  addDeviceTitle:          "Neues Gerät hinzufügen",
  addDeviceIntro:          "Folge diesen Schritten — dein Passkey bleibt sicher auf diesem Gerät.",
  addDeviceStep1:          "Auf dem neuen Gerät renex.id öffnen.",
  addDeviceStep2:          "Deinen Handle eingeben und einloggen — der Browser zeigt dort einen QR-Code.",
  addDeviceStep3:          "Diesen QR-Code mit der Kamera-App dieses Geräts scannen.",
  addDeviceStep4:          "Mit Touch-ID / Face-ID bestätigen — fertig.",
  addDeviceConvenienceTip: "💡 Tipp: Scanne diesen QR mit der Kamera deines neuen Geräts, um renex.id direkt zu öffnen (spart das URL-Eintippen).",
  addDeviceHint:           "🔒 Dein Passkey bleibt auf diesem Gerät — er wird nie übertragen. Das neue Gerät erstellt einen eigenen Passkey, den dein bestehender per QR-Scan bestätigt.",
  addDeviceAppleNotice:    "✨ Auf Apple-Geräten mit gemeinsamer iCloud-ID erscheint stattdessen automatisch eine Bestätigungs-Benachrichtigung — dann kannst du Schritt 3 überspringen.",
  addDeviceQrError:        "QR-Code konnte nicht erzeugt werden.",
  addDeviceCloseBtn:       "Verstanden",

  // ── Servers (Phase 3A) ───────────────────────────────
  serversLabel:                       "Server",
  serversEmpty:                       "Noch keine Server.",
  memberSingular:                     "Mitglied",
  channelsHeading:                    "Channels",
  membersHeading:                     "Mitglieder",
  createServerBtn:                    "+ Server erstellen",
  createServerTitle:                  "Server erstellen",
  createServerIntro:                  "Erstelle einen Hub mit eigenen Channels für deine Community.",
  createServerNameLabel:              "Name",
  createServerNamePlaceholder:        "z.B. Mein Clan",
  createServerDescLabel:              "Beschreibung (optional)",
  createServerDescPlaceholder:        "Worum geht es?",
  createServerSubmitBtn:              "Server erstellen",
  createServerNameRequired:           "Name ist erforderlich",
  createServerNameTooLong:            "Name zu lang (max 80 Zeichen)",
  createServerSuccess:                "✅ Server erstellt",
  createServerFailed:                 "Erstellen fehlgeschlagen",
  createServerLimitReached:           "Maximal {limit} Server erreicht.",
  tooManyRequests:                    "Zu viele Anfragen — bitte kurz warten.",
  creating:                           "Erstelle…",
  leaveServerBtn:                     "Server verlassen",
  leaveServerConfirm:                 "Server „{name}\" verlassen?",
  leaveServerOwnerConfirm:            "Du bist Owner. Wenn andere Mitglieder existieren, musst du zuerst transferieren. Trotzdem versuchen?",
  leaveServerOwnerTransferRequired:   "⚠ Übergib das Eigentum erst an ein anderes Mitglied.",
  leaveServerFailed:                  "Verlassen fehlgeschlagen",
  serverDeletedToast:                 "🗑 Server gelöscht (du warst Solo-Owner)",
  serverLeftToast:                    "👋 Server verlassen",
  channelSendNotReady:                "📡 Channel-Nachrichten kommen in Phase 4b.",

  // ── Server-Settings + Role-Editor (Phase 3A.5) ────────
  serverSettingsBtn:        "Server-Einstellungen",
  serverSettingsTitle:      "Server-Einstellungen",
  tabRoles:                 "Roles",
  tabMembers:               "Mitglieder",
  rolesReadOnly:            "👁 Read-only — du brauchst MANAGE_ROLES um Roles zu bearbeiten.",
  membersReadOnly:          "👁 Read-only — du brauchst MANAGE_ROLES um Member-Roles zu ändern.",
  tabChannels:              "Channels",
  channelsAutoDeleteReadOnly: "👁 Read-only — du brauchst MANAGE_CHANNELS um Auto-Delete zu ändern.",
  channelsAutoDeleteHint:   "Auto-Delete löscht Nachrichten im Channel nach Ablauf für alle Mitglieder. Alle bekommen eine System-Nachricht.",
  // ── Phase 3A.5: General-Tab (Server-Icon + Name/Beschreibung) ─────────
  tabGeneral:               "Allgemein",
  iconSectionTitle:         "Server-Icon",
  iconChooseBtn:            "Bild auswählen",
  iconRemoveBtn:            "Entfernen",
  iconRemoveConfirm:        "Server-Icon wirklich entfernen?",
  iconHint:                 "PNG, JPEG oder WebP — max 1 MB. Auto-Upload beim Auswählen.",
  iconErrorMime:            "Nur PNG, JPEG oder WebP",
  iconErrorSize:            "Datei zu groß (max 1 MB)",
  iconUploadedToast:        "✅ Server-Icon aktualisiert",
  iconRemovedToast:         "🗑 Server-Icon entfernt",
  iconUploadFailed:         "Icon-Upload fehlgeschlagen",
  iconRemoveFailed:         "Entfernen fehlgeschlagen",
  profileSectionTitle:      "Name & Beschreibung",
  serverNameLabel:          "Name",
  serverDescLabel:          "Beschreibung",
  nameRequired:             "Name darf nicht leer sein",
  serverSavedToast:         "✅ Server-Einstellungen gespeichert",
  // ── Phase 3A.5: Ban-System ────────────────────────────
  tabBanned:                "Gebannt",
  banBtn:                   "Bannen",
  banConfirm:               "User @{handle} wirklich bannen? Er wird sofort entfernt und kann nicht via Invite zurückkommen.",
  banReasonPrompt:          "Grund (optional, leer lassen wenn keiner):",
  bannedToast:              "🚫 @{handle} gebannt",
  banFailed:                "Bannen fehlgeschlagen",
  unbanBtn:                 "Unban",
  unbanConfirm:             "Ban für @{handle} aufheben? Er kann dann wieder via Invite joinen.",
  unbannedToast:            "✅ Ban für @{handle} aufgehoben",
  unbanFailed:              "Unban fehlgeschlagen",
  bansEmpty:                "Keine aktiven Bans auf diesem Server.",
  bansHint:                 "🚫 Gebannte User können nicht via Invite re-joinen. Unban hebt das auf.",
  bannedByLabel:            "Gebannt von",
  cannotBanOwner:           "Owner kann nicht gebannt werden",
  cannotBanSelf:            "Du kannst dich nicht selbst bannen",
  bannedFromServerToast:    "Du wurdest vom Server gebannt",
  // ── Phase 3A.5: Private Channels ──────────────────────
  tabPermissions:           "Berechtigungen",
  privateBadge:             "privat",
  privateChannelToggle:     "Privater Channel",
  privateOnHint:            "Nur Mitglieder mit explizitem Zugriff (unten) sehen diesen Channel. Owner + ADMINISTRATOR sehen ihn immer.",
  privateOffHint:           "Alle Server-Mitglieder sehen diesen Channel.",
  accessListTitle:          "Wer hat Zugriff",
  accessEmpty:              "Noch niemand mit explizitem Zugriff — nur Owner + ADMINISTRATOR sehen den Channel.",
  addRoleSelect:            "+ Role hinzufügen…",
  addMemberSelect:          "+ Member hinzufügen…",
  channelName:              "Name",
  channelTopic:             "Thema",
  channelEditHint:          "Klicken zum Editieren (Name, Thema, Berechtigungen)",
  channelSavedToast:        "✅ Channel gespeichert",
  remove:                   "Entfernen",
  add:                      "Hinzufügen",
  loading:                  "Lädt…",
  // ── Phase 3A.5: Tier-Limits ───────────────────────────
  createServerLimitReachedFree: "Server-Limit erreicht (max {limit} als Owner im Free-Tier). Upgrade auf Pro für {proLimit}.",
  createServerLimitReachedPro:  "Server-Limit erreicht (max {limit} als Pro-Owner).",
  // ── Phase 5-Light: Turnstile + ServerJoinModal ────────
  joining:                  "Beitrete…",
  inviteJoinTitle:          "Server-Einladung",
  inviteJoinBtn:            "Beitreten",
  inviteFrom:               "von @{handle}",
  inviteMemberCount:        "{count} Mitglieder",
  inviteUserBanned:         "Du wurdest von diesem Server gebannt und kannst nicht beitreten.",
  inviteServerFull:         "Server ist voll.",
  inviteExpired:            "Invite-Link ist abgelaufen.",
  inviteUsedUp:             "Invite-Link wurde schon aufgebraucht.",
  roleCreateBtn:            "Role erstellen",
  roleCreateTitle:          "Role erstellen",
  roleEditTitle:            "Role bearbeiten",
  roleDefault:              "default",
  roleDefaultLocked:        "Default-Role — nicht entfernbar",
  roleDefaultHint:          "🛡 Default-Role „everyone\" — Name und Position sind fixiert. Permissions änderbar.",
  roleEdit:                 "Bearbeiten",
  roleAssign:               "Zuweisen",
  roleRevoke:               "Entfernen",
  roleNameLabel:            "Name",
  roleNamePlaceholder:      "z.B. Moderator",
  roleNameRequired:         "Name ist erforderlich",
  roleNameTooLong:          "Name zu lang (max 64 Zeichen)",
  roleColorLabel:           "Farbe",
  rolePositionLabel:        "Position",
  roleMentionableLabel:     "@-Erwähnung erlaubt (z.B. @Moderator)",
  roleCreated:              "✅ Role erstellt",
  roleUpdated:              "✅ Role aktualisiert",
  roleDeleted:              "🗑 Role gelöscht",
  roleDeleteConfirm:        "Role „{name}\" wirklich löschen?",
  owner:                    "Owner",
  permissionsHeading:       "Berechtigungen",
  permGroupGeneral:         "Allgemein",
  permGroupModeration:      "Moderation",
  permGroupServer:          "Server-Verwaltung",
  permGroupVoice:           "Voice (Phase 8)",
  permGroupAdmin:           "⚠ Super-Admin",
  permViewChannel:          "Channels sehen",
  permSendMessages:         "Nachrichten senden",
  permMentionEveryone:      "@everyone erwähnen",
  permManageMessages:       "Nachrichten löschen/pinnen",
  permKickMembers:          "Mitglieder kicken",
  permBanMembers:           "Mitglieder bannen (Phase 3A.5)",
  permManageChannels:       "Channels verwalten",
  permManageRoles:          "Roles verwalten",
  permManageServer:         "Server-Settings ändern",
  permInviteMembers:        "Mitglieder einladen",
  permVoiceConnect:         "Voice-Channel beitreten",
  permVoiceSpeak:           "In Voice-Channel sprechen",
  permAdministrator:        "ADMINISTRATOR — Bypass aller Permission-Checks",
  permAdminOwnerOnly:       "nur Owner",
  errForbiddenManageRoles:  "Keine Berechtigung (MANAGE_ROLES)",
  errForbiddenRolePosition: "Position zu hoch — du kannst nur Roles unter deiner eigenen verwalten",
  errForbiddenAdminBit:     "ADMINISTRATOR-Bit kann nur der Owner setzen",
  errCannotDeleteDefault:   "Default-Role kann nicht gelöscht werden",
  errReservedName:          "Name reserviert (everyone)",
  create:                   "Erstellen",
  save:                     "Speichern",
  saving:                   "Speichere…",
  delete:                   "Löschen",
  error:                    "Fehler",

  // ── Passkey-Verwaltung ────────────────────────────────
  passkeysLabel:           "Passkeys",
  passkeysTitle:           "Passkeys verwalten",
  passkeyAdd:              "+ Passkey hinzufügen",
  passkeyAdding:           "Passkey wird erstellt…",
  passkeyAdded:            "Passkey hinzugefügt",
  passkeyAddFailed:        "Passkey konnte nicht hinzugefügt werden",
  passkeyDelete:           "Entfernen",
  passkeyDeleteConfirm:    "Diesen Passkey wirklich entfernen?",
  passkeyDeleteLast:       "Der letzte Passkey kann nicht entfernt werden",
  passkeyDeleted:          "Passkey entfernt",
  passkeyDeleteFailed:     "Passkey konnte nicht entfernt werden",
  passkeyRename:           "Umbenennen",
  passkeyRenamePlaceholder: "z.B. iPhone, MacBook…",
  passkeyRenamed:          "Passkey umbenannt",
  passkeyRenameFailed:     "Umbenennen fehlgeschlagen",
  passkeyCreated:          "Erstellt",
  passkeyLastUsed:         "Zuletzt benutzt",
  passkeyNeverUsed:        "Nie benutzt",
  passkeyUnnamed:          "Unbenannt",
  passkeyLoadFailed:       "Passkeys konnten nicht geladen werden",
  passkeyNamePrompt:       "Name für diesen Passkey (optional):",

  // ── Empty States ─────────────────────────────────────
  selectChatHint:      "Wähle einen Chat",
  noCallsYet:          "Noch keine Anrufe",
  openChatForCall:     "Öffne einen Chat und tippe oben auf 📞",

  // ── Locale ───────────────────────────────────────────
  locale: "de-DE",

  // ── Push Notifications ──────────────────────────────
  pushBannerTitle:      "Benachrichtigungen aktivieren",
  pushBannerSubtitle:   "Verpasse keine Nachrichten",
  pushBannerActivating: "Wird aktiviert…",
  pushBannerBlocked:    "Benachrichtigungen blockiert",

  // ── Debug / Diagnose ────────────────────────────────
  debugLabel:  "Debug / Diagnose",
  debugTitle:  "Debug / Diagnose",
  debugHint:   "Tipp: Sperre dein Telefon nach \"Test-Push senden\" und warte 5-10 Sekunden. Wenn du eine Push-Notification siehst → Notifications funktionieren. Wenn nicht: Status oben prüfen + Resultat in Zwischenablage kopieren.",

  // ── Version-Update-Banner ───────────────────────────
  newVersionAvailable: "Neue Version verfügbar",
  reloadNow:           "Jetzt aktualisieren",
  dismissBtn:          "Schliessen",
};
